import { render, staticRenderFns } from "./InterpretersList.vue?vue&type=template&id=2330eafb&scoped=true&"
import script from "./InterpretersList.vue?vue&type=script&lang=js&"
export * from "./InterpretersList.vue?vue&type=script&lang=js&"
import style0 from "./InterpretersList.vue?vue&type=style&index=0&id=2330eafb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2330eafb",
  null
  
)

export default component.exports